// from WorldFactory
export const worldDeployedEvent = "event WorldDeployed(address indexed newContract, uint256 salt)";

// from World
export const helloWorldEvent = "event HelloWorld(bytes32 indexed worldVersion)";
